export default "__VITE_ASSET__CscgfUU4__"